var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-server-network","label":_vm.$t('integrations.btn.deploy_all'),"text":""},on:{"click":function($event){return _vm.exec()}}})}
var staticRenderFns = []

export { render, staticRenderFns }